
import { Injectable, ElementRef } from '@angular/core';
import { ModalContent, NG_Modal } from './modal';

@Injectable({ providedIn: 'root' })
export class NG_ModalService {
	public modalComponent!: NG_Modal;
	
	constructor() { 

	}

	registerModal(modal: NG_Modal) {
		this.modalComponent = modal;
	}

	setContent(obj: ModalContent) {
		if ( this.modalComponent ) {
			this.modalComponent.setContent(obj);
		} 
	}

	clearContent() {
		if ( this.modalComponent ) {
			this.modalComponent.setContent({
				title: '',
				bodyStrings: [],
				buttons: []
			});
		}
	}

	showModal() {
		if ( this.modalComponent ) {
			this.modalComponent.open();
		}
	}

	hideModal() {
		if ( this.modalComponent ) {
			this.modalComponent.close();
		}
	}

}